var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRoundedUp13X8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 8,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4,7.7l-4.9-5l-4.9,5c-0.4,0.4-0.9,0.4-1.3,0l0,0c-0.4-0.4-0.4-0.9,0-1.3L6.5,0l6.2,6.4c0.4,0.4,0.3,0.9,0,1.3l0,0 C12.4,8.1,11.8,8.1,11.4,7.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRoundedUp13X8);
export default __webpack_public_path__ + "static/media/arrow-rounded-up-13x8.6b0525ad.svg";
export { ForwardRef as ReactComponent };